/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { _date } from '@mairistem/administres-utils';
import { Table } from '@mairistem/composants';

import type { Acte } from '@/types';

interface Props {
  acte: Acte;
}

const ActeTableLineReconnaissance = ({ acte }: Props) => {
  let pere = '';
  if (acte.nomClassementPere) {
    pere = `le ${_date.short(acte?.dateReconnaissancePere)} par ${acte?.nomClassementPere}`;
  }

  let mere = '';
  if (acte.nomClassementMere) {
    mere = `le ${_date.short(acte?.dateReconnaissanceMere)} par ${acte?.nomClassementMere}`;
  }

  return (
    <>
      <Table.Cell content={acte.nomClassementEnfant} />
      <Table.Cell content={pere} />
      <Table.Cell content={mere} />
    </>
  );
};

export default ActeTableLineReconnaissance;
